/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2015
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

 
define([
    "client/sourceinfo",
    "i18n/i18n",
    "api/v2/common",
    "backbone",
    "underscore",
    "model/tree",
    "model/readonlytree",
    "service/stub",
    "service/factory",
    "service/channels"
  ],
  function(
    SourceInfo,
    i18n,
    Common,
    Backbone,
    _,
    TreeModel,
    ReadOnlyTreeModel,
    Stub,
    ServiceFactory,
    Channels
  ){
  // TODO: use messageframe instead

    var Resources = function () {
}

    var ResourcesServiceStub = Resources.ResourcesServiceStub = Stub.extend({
        path: "resource",

        call: function(channel, request, responseObserver) {
          if (_.isFunction(channel.prepareRequest)) {
            request = _.clone(request);
            channel.prepareRequest(request);
          }
          if (request.id) {
            return channel.call("put" + this.path, request, responseObserver, { }, null, {
                method: "POST"
            });
          } else {
            return channel.call(this.path + "/" + encodeURI(request), null, responseObserver, { dataType: "text" }, null, {
                method: "GET"
            });
          }
        }
    });

    var ResourcesServiceFactory = Resources.ServiceFactory = function() {}
    _.extend(ResourcesServiceFactory.prototype, ServiceFactory.prototype, {

      get: function (id, callback, channel) {
        var stub = new ResourcesServiceStub(),
            string_content,
            responseObserver = this._responseObserver = {},
            errors,
            promise;

        _.extend(responseObserver, Backbone.Events);
        this._responseObserver.on("response", function (response) {
            string_content = response;
        });

        this._responseObserver.on("error", function (error) {
            if (!errors) errors = [];  
            errors.push(error);
        });

        promise = new ResourcesServiceStub().cast(channel, id, responseObserver, {
            method: "GET"
        });
        promise.always(function() { 
            try {
              callback(string_content, errors);
            } catch (e) {
              if (console && console.error) console.error(e, e.stack);
            }
        });
        return promise;
      },

      put: function (id, string_content, channel) {
        var responseObserver = this._responseObserver = {},
            errors,
            promise;

        _.extend(responseObserver, Backbone.Events);
        this._responseObserver.on("response", function (response) {
            string_content = response;
        });

        this._responseObserver.on("error", function (error) {
            if (!errors) errors = [];  
            errors.push(error);
        });

        promise = new ResourcesServiceStub().cast(channel, {
          id: id,
          string_content: string_content
        }, responseObserver, {
        });

        promise.always(function() { 
            try {
            //    callback(string_content, errors);
            } catch (e) {
              if (console && console.error) console.error(e, e.stack);
            }
        });
        return promise;
      }

    });

    return Resources;
});
